module.exports = __webpack_public_path__ + "static/media/union.af9a599b.svg";